import BaseApi from "../../../services/baseApi";

class Profile_se {
    constructor() {
        this.entity = 'user';
    }

    getUser() {
        return BaseApi({requiresAtuh: true})({
            method: 'GET',
            url: '/private/'+this.entity+'/getUser/',
            headers: {'Content-Type': 'application/json'},
        })
    }
 changePass(model) {

        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:model,
            url: '/private/'+this.entity+'/changePass/',
            headers: {'Content-Type': 'application/json'},
        })
    }

    forgetPass(mobile,code,codeUser) {

        let formData=new FormData()
        formData.append("mobile",mobile)
        formData.append("code",code)
        formData.append("codeUser",codeUser)
        return BaseApi({requiresAtuh: false})({
            method: 'POST',
            data:formData,
            url: '/public/forgetPass',
            headers: {'Content-Type': 'application/json'},
        })
    }





}
export default new Profile_se();
